var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5273_13552)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81021 13.3546C4.74343 13.3546 2.25445 10.8656 2.25445 7.7988C2.25445 5.92037 3.18899 4.25832 4.61711 3.25244C5.01362 2.97406 5.10836 2.42667 4.82998 2.03017C4.55044 1.63483 4.00305 1.53892 3.60772 1.81847C1.72812 3.14132 0.5 5.32737 0.5 7.7988C0.5 11.8329 3.77497 15.109 7.81021 15.109C8.29444 15.109 8.68744 14.716 8.68744 14.2318C8.68744 13.7476 8.29444 13.3546 7.81021 13.3546Z",
    fill: "#36A4CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16829 2.25283C11.0678 2.43764 13.3661 4.85059 13.3661 7.7969C13.3661 9.49053 12.6071 11.0075 11.4105 12.0263C11.0421 12.3409 10.9976 12.8953 11.3123 13.2638C11.6257 13.6322 12.1801 13.6755 12.5486 13.362C14.1217 12.0204 15.1206 10.0239 15.1206 7.7969C15.1206 3.92073 12.0959 0.745177 8.28058 0.501893C7.79752 0.470313 7.37996 0.837578 7.34955 1.32181C7.31797 1.80486 7.68523 2.22125 8.16829 2.25283Z",
    fill: "#36A4CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6224 12.1788H12.192V9.74832C12.192 9.26409 11.799 8.87109 11.3147 8.87109C10.8305 8.87109 10.4375 9.26409 10.4375 9.74832V13.056C10.4375 13.5403 10.8305 13.9333 11.3147 13.9333H14.6224C15.1067 13.9333 15.4997 13.5403 15.4997 13.056C15.4997 12.5718 15.1067 12.1788 14.6224 12.1788Z",
    fill: "#36A4CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.37723 2.82672H3.80772V5.25722C3.80772 5.74144 4.20072 6.13444 4.68495 6.13444C5.16918 6.13444 5.56218 5.74144 5.56218 5.25722V1.94949C5.56218 1.46526 5.16918 1.07227 4.68495 1.07227H1.37723C0.892997 1.07227 0.5 1.46526 0.5 1.94949C0.5 2.43372 0.892997 2.82672 1.37723 2.82672Z",
    fill: "#36A4CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5273_13552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/retry.88b447e0c7cb203943c8594087500dad.svg";
export { ForwardRef as ReactComponent };